import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'
import InputFile from 'components/InputFile'

import { UPDATE_DOCUMENTS_URL } from 'constants'

import { edittingDocumentsChanged } from 'scenes/VehicleDetail/components/Data/actions'
import { documentsChanged } from 'scenes/VehicleDetail/actions'
import { statusChanged } from 'components/RequestStatus/actions'


export class EditForm extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      makers: [],
      fileLicense: {
        message: 'No se ha seleccionado archivo',
        file: null,
        status: false
      },
      fileCirculation: {
        message: 'No se ha seleccionado archivo',
        file: null,
        status: false
      },
      fileInvoice: {
        message: 'No se ha seleccionado archivo',
        file: null,
        status: false
      }
    }
    this._bind('_handleFileChange', '_onSubmit')
  }

  _handleFileChange(e) {
    e.preventDefault()
    this.setState({
      [e.target.name]: {
        message: 'Archivo seleccionado',
        file: e.target.files[0],
        status: true
      }
    })
  }

  _onSubmit(evt) {
    evt.preventDefault()
    this.props.edittingDocumentsChanged(false)

    if(this.state.fileLicense.status) {this._updateFile(this.state.fileLicense.file, 'LC')}
    if(this.state.fileCirculation.status) {this._updateFile(this.state.fileCirculation.file, 'TC')}
    if(this.state.fileInvoice.status) {this._updateFile(this.state.fileInvoice.file, 'FV')}
  }

  _updateFile(file, type) {
    const userId = this.props.userId
    const vehicleId = this.props.vehicleId

    let formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)
    this.props.updateRequestStatus('progress', 'Actualizando Archivos')

    request(UPDATE_DOCUMENTS_URL(userId, vehicleId), {
      method: 'POST',
      isUpload: true,
      body: formData
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        this.props.documentsChanged(res.documents)
      })
      .catch((err) => {
        this.props.updateRequestStatus('error', err.message)
      })
  }

  render() {
    return (
      <form onSubmit={this._onSubmit} className="Documents__form">
        <InputFile  name="fileLicense"
                    labelType="bold"
                    label="Archivo licencia de conducir"
                    file={this.state.fileLicense.file}
                    onChange={this._handleFileChange} />

        <InputFile  name="fileCirculation"
                    labelType="bold"
                    label="Archivo tarjeta de circulación"
                    file={this.state.fileCirculation.file}
                    onChange={this._handleFileChange} />

        <InputFile  name="fileInvoice"
                    labelType="bold"
                    label="Archivo factura del vehículo"
                    file={this.state.fileInvoice.file}
                    onChange={this._handleFileChange} />

        <div className="controls d-flex justify-content-end">
          <Button size="small">Actualizar datos</Button>
        </div>
      </form>
    )
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    edittingDocumentsChanged: (edittingDocuments) => dispatch(edittingDocumentsChanged(edittingDocuments)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    documentsChanged: (documents) => dispatch(documentsChanged(documents))
  }
}

export default connect(null, mapDispatchToProps)(EditForm)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/Documents/EditForm.js